class StarryProductGallery extends HTMLElement {
  connectedCallback() {
    if (this.dataset.starryGalleryReady === 'true') return;

    this.dataset.starryGalleryReady = 'true';
    this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
    this.thumbnails = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
    this.previousButton = this.querySelector('[data-gallery-prev]');
    this.nextButton = this.querySelector('[data-gallery-next]');
    this.activeIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));

    if (this.activeIndex < 0) this.activeIndex = 0;

    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        this.setActive(Number(thumbnail.dataset.galleryThumb));
      });
      thumbnail.addEventListener('keydown', (event) => this.handleThumbnailKeydown(event));
    });

    this.previousButton?.addEventListener('click', () => this.setActive(this.activeIndex - 1));
    this.nextButton?.addEventListener('click', () => this.setActive(this.activeIndex + 1));

    this.setActive(this.activeIndex);
  }

  handleThumbnailKeydown(event) {
    const keyActions = {
      ArrowLeft: () => this.activeIndex - 1,
      ArrowRight: () => this.activeIndex + 1,
      Home: () => 0,
      End: () => this.thumbnails.length - 1,
    };
    const getNextIndex = keyActions[event.key];

    if (!getNextIndex) return;

    event.preventDefault();
    this.setActive(getNextIndex());
    this.thumbnails[this.activeIndex]?.focus();
  }

  setActive(index) {
    const slideCount = this.slides.length;
    if (slideCount === 0) return;

    this.activeIndex = (index + slideCount) % slideCount;

    this.slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === this.activeIndex;
      slide.classList.toggle('is-active', isActive);
      if (isActive) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });

    this.thumbnails.forEach((thumbnail, thumbnailIndex) => {
      const isActive = thumbnailIndex === this.activeIndex;
      thumbnail.classList.toggle('is-active', isActive);
      thumbnail.setAttribute('aria-selected', String(isActive));
      thumbnail.setAttribute('tabindex', isActive ? '0' : '-1');
    });
  }
}

if (!customElements.get('starry-product-gallery')) {
  customElements.define('starry-product-gallery', StarryProductGallery);
}
